import { swalMessages } from '@auteco/constants'
import React, { useState, useEffect } from 'react'
import PartnersPage from 'src/pages/GvcPage/PartnersPage/PartnersPage'
import { getPartners, postQuiz, putPartners } from 'src/services/GvcServices'
import swal from 'sweetalert'

const PartnersContainer = () => {
  const [partners, setPartners] = useState([])

  const fetchPartners = async () => {
    const { success, data } = await getPartners()
    if (success) {
      setPartners(data)
    } else {
      swal(swalMessages.GENERAL_ERROR)
    }
  }

  const updatePartners = async ({ newData }) => {
    const { success, data } = await putPartners({
      id: newData.id,
      correo: newData.correo,
    })
    if (success) {
      setPartners(data)
    } else {
      swal(swalMessages.GENERAL_ERROR)
    }
  }

  const generateQuiz = async (selectedPartners) => {
    if (selectedPartners.length === 0) {
      swal(swalMessages.NOT_SELECTED)
    } else {
      const allselected = selectedPartners.map((partner) => partner.correo)
      const { success, data } = await postQuiz({
        socios: allselected,
      })
      if (success) {
        setPartners(data)
        swal(swalMessages.SUCCESSFUL_MESSAGE)
      } else {
        swal(swalMessages.GENERAL_ERROR)
      }
    }
  }

  useEffect(() => {
    fetchPartners()
  }, [])

  return (
    <PartnersPage
      partners={partners}
      updatePartners={updatePartners}
      generateQuiz={generateQuiz}
    />
  )
}

export default PartnersContainer
